function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EventEmitter from 'eventemitter3';
export class Gesture extends EventEmitter {
  constructor(element, scope) {
    super();
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "scope", void 0);
    _defineProperty(this, "lastVector", null);
    _defineProperty(this, "lastPoint", null);
    _defineProperty(this, "onTouchStart", evt => {
      if (evt.touches.length > 1) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      } else {
        return;
      }
      const p1 = new this.scope.Point(evt.touches[0].pageX, evt.touches[0].pageY);
      const p2 = new this.scope.Point(evt.touches[1].pageX, evt.touches[1].pageY);
      this.lastVector = p2.subtract(p1);
      this.lastPoint = p1;
    });
    _defineProperty(this, "onTouchMove", evt => {
      if (this.lastVector && this.lastPoint && evt.touches.length === 2) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        const p1 = new this.scope.Point(evt.touches[0].pageX, evt.touches[0].pageY);
        const p2 = new this.scope.Point(evt.touches[1].pageX, evt.touches[1].pageY);
        const currentVector = p2.subtract(p1);
        // 双指移动
        if (Math.abs(this.lastVector.length - currentVector.length) < 5) {
          this.emit('offset', p1.x - this.lastPoint.x, p1.y - this.lastPoint.y);
        } else {
          // 双指缩放
          this.emit('scale', currentVector.length / this.lastVector.length, new this.scope.Point({
            x: (p2.x + p1.x) / 2,
            y: (p2.y + p1.y) / 2
          }));
        }
        this.lastPoint = p1;
        this.lastVector = currentVector;
      } else if (evt.touches.length === 2) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        const p1 = new this.scope.Point(evt.touches[0].pageX, evt.touches[0].pageY);
        const p2 = new this.scope.Point(evt.touches[1].pageX, evt.touches[1].pageY);
        this.lastVector = p2.subtract(p1);
        this.lastPoint = p1;
      } else {
        this.lastVector = null;
        this.lastPoint = null;
      }
    });
    _defineProperty(this, "onTouchEnd", () => {
      this.lastVector = null;
      this.lastPoint = null;
    });
    this.element = element;
    this.scope = scope;
    this.element.addEventListener('touchstart', this.onTouchStart);
    this.element.addEventListener('touchmove', this.onTouchMove);
    this.element.addEventListener('touchend', this.onTouchEnd);
  }
}